import { Link } from "react-router-dom";
import { Facebook, Instagram, MapPin, Phone, Mail } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { HOURS } from "../i18n/translations";

export const Footer = () => {
  const { t } = useLanguage();
  const quickLinks = [
    { to: "/bowling", key: "nav.bowling" },
    { to: "/arrangementen", key: "nav.arrangements" },
    { to: "/kinderfeestjes", key: "nav.kids" },
    { to: "/restaurant", key: "nav.restaurant" },
    { to: "/contact", key: "nav.contact" },
    { to: "/faq", key: "nav.faq" },
  ];

  return (
    <footer className="relative border-t border-[#00F0FF]/10 bg-[#04060a] overflow-hidden" data-testid="footer">
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-[#00F0FF]/10 blur-[120px] rounded-full pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4 relative">
        <div>
          <p className="font-brand text-2xl neon tracking-[0.2em] uppercase mb-4">HELIOS</p>
          <p className="text-[#9db8d6] text-sm italic">{t("footer.tagline")}</p>
          <div className="flex gap-3 mt-6">
            <a data-testid="social-facebook" href="https://www.facebook.com/bowlingheliosBalen/" target="_blank" rel="noreferrer"
              className="w-10 h-10 rounded-full border border-[#00F0FF]/30 flex items-center justify-center text-[#00F0FF] hover:bg-[#00F0FF]/10 transition-colors">
              <Facebook size={17} />
            </a>
            <a data-testid="social-instagram" href="https://www.instagram.com/bowlinghelios" target="_blank" rel="noreferrer"
              className="w-10 h-10 rounded-full border border-[#00F0FF]/30 flex items-center justify-center text-[#00F0FF] hover:bg-[#00F0FF]/10 transition-colors">
              <Instagram size={17} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-display text-lg uppercase tracking-widest text-[#00F0FF] mb-4">{t("footer.links")}</h4>
          <ul className="space-y-2">
            {quickLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-link-${l.key.split(".")[1]}`} className="text-sm text-[#9db8d6] hover:text-[#00F0FF] transition-colors">
                  {t(l.key)}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg uppercase tracking-widest text-[#00F0FF] mb-4">{t("footer.contactTitle")}</h4>
          <ul className="space-y-3 text-sm text-[#9db8d6]">
            <li className="flex gap-2 items-start"><MapPin size={15} className="text-[#F0C971] mt-0.5 shrink-0" /> Gerheide 48, 2490 Balen</li>
            <li><a data-testid="footer-phone" href="tel:+3214812093" className="flex gap-2 items-center hover:text-[#00F0FF] transition-colors"><Phone size={15} className="text-[#F0C971]" /> +32 (0)14 81 20 93</a></li>
            <li><a data-testid="footer-email" href="mailto:heliosbowling@gmail.com" className="flex gap-2 items-center hover:text-[#00F0FF] transition-colors"><Mail size={15} className="text-[#F0C971]" /> heliosbowling@gmail.com</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg uppercase tracking-widest text-[#00F0FF] mb-4">{t("footer.hoursTitle")}</h4>
          <ul className="space-y-1.5 text-sm text-[#9db8d6]">
            {HOURS.map((h) => (
              <li key={h.day} className="flex justify-between gap-4">
                <span>{t(`hours.${h.day}`)}</span>
                <span className={h.time ? "text-[#E2F1FF]" : "text-[#F0C971]"}>{h.time || t("hours.closed")}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 pb-12 text-center relative">
        <Link
          to="/reserveer"
          data-testid="footer-book-cta"
          className="btn-neon font-display text-xl tracking-[0.25em] uppercase px-14 py-5 rounded-full inline-block"
        >
          {t("nav.book")}
        </Link>
        <p className="mt-8 text-xs text-[#5b7191]">© 2026 Bowling Helios · {t("footer.rights")}</p>
      </div>
    </footer>
  );
};
